<template lang="pug">
  .scroll-top(@click="scrollTop")
    .scroll-top__button
      SvgIcon.scroll-top__button-ico(name="arrow-left2" width="18" height="16")
    .scroll-top__title К началу страницы
</template>

<script>

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  export default {
    name: 'ScrollTop',

    components: {
      SvgIcon,
    },

    created() {
      this.$nextTick(() => {
        this.checkScrollTop()

        $(window).on('scroll', () => {
          this.checkScrollTop()
        })
      })
    },

    methods: {
      scrollTop() {
        $('html, body').stop().animate({
          scrollTop: 0
        }, 1500);
      },

      checkScrollTop() {
        if($(window).scrollTop() >= 200) {
          $('.scroll-top').removeClass('scroll-top--hide')
        } else {
          $('.scroll-top').addClass('scroll-top--hide')
        }
      }
    }
  }
</script>
